<template>
    <li class="nav-item dropdown"  @mouseenter="enteredhover" @mouseleave="exitedhover">
        <a @click="toggleStatus" class="nav-link">
            <slot name="activator"></slot>
        </a>

        <ul :class="dropdownClass" :style="{ 'display': hover ? 'block' : 'none' }">
            <slot name="items"></slot>
        </ul>
    </li>
</template>

<script>
export default {
    name: "Dropdown",
    props: {
        leftMenu: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        dropdownClass: function() {
            return {
                'dropdown-menu': true,
                'dropdown-menu-right': this.leftMenu
            }
        }
    },
    methods: {
        enteredhover: function() {
            if (!this.$isMobile()) {
                this.hover = true;
            }
        },
        exitedhover: function() {
            if (!this.$isMobile()) {
                this.hover = false;
            }
        },
        toggleStatus: function() {
            this.hover = !this.hover;
        }
    },
    data() {
        return {
            hover: false
        }
    }

}
</script>

<style lang="scss" scoped>

.nav-item {
    border: none;
    padding-left: 15px;
    padding-right: 15px;

    a {
        line-height: 24px;
        font-size: 14px;
        text-align: center;
        font-style: normal;
        text-transform: capitalize;

        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &:hover, &:hover > * {
        cursor: pointer;
        color: $primary-dark !important;
        text-decoration: none
    }
}

.dropdown-menu {
    width: 100%;
    min-width: 250px;
    margin: 0;
    padding: 0;
}


@media (max-width: 991.98px) {
    .dropdown-menu {
        padding: 0.75rem 0 0.75rem 0.75rem;
    }   

    .nav-item {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        border-bottom: 1px solid $primary-color;
    }

    .nav-item .nav-link {
        padding: 0.75rem 0 0.75rem 0.75rem;
    }
}


@media (max-width: 1199.98px) {
  .nav-link {
    font-size: 12px !important;
  }
}
</style>
